import { Modal } from 'react-bootstrap'
import useToggle from '@/hooks/useToggle'
import SignInForm from './SignInForm'
import SignUpForm from './SignUpForm'

const AuthModal = ({ show, onHide }) => {
  const { isTrue: showSignUp, toggle: toggleSignUp } = useToggle()

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{showSignUp ? 'Sign Up' : 'Sign In'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showSignUp ? <SignUpForm onSignInClick={toggleSignUp} /> : <SignInForm onSignUpClick={toggleSignUp} onLoginSuccess={onHide} />}
      </Modal.Body>
    </Modal>
  )
}

export default AuthModal
